import { useState } from 'react'
import { UpcomingPayroll } from '../../../../redux/types'
import usePayrollActions from '../../../../hooks/usePayrollActions'

/**
 * Hook for managing the file upload modal
 */
const useFileUploadModal = (upcomingPayroll: UpcomingPayroll) => {
  const [visible, setVisible] = useState<boolean>(false)
  const { uploadPayrollFile, uploadOffCyclePayrollFile } = usePayrollActions()

  const handleUpload = (file: File) => {
    const externalId = new Date().getTime().toString()
    if (upcomingPayroll.offCycle) {
      uploadOffCyclePayrollFile(externalId, upcomingPayroll.paymentDate, file)
    } else {
      uploadPayrollFile(externalId, upcomingPayroll.paymentDate, file)
    }
    setVisible(false)
  }

  return {
    visible,
    show: () => setVisible(true),
    hide: () => setVisible(false),
    handleUpload
  }
}

export default useFileUploadModal 